const StorageKeys = {
  AccessToken: 'access-token',
  RefreshToken: 'refresh-token'
};

export default StorageKeys;
